module.exports = __webpack_public_path__ + "img/page.d55067c0.png";